import axios from '@/plugins/axios'

export default {
  save(data, id) {
    return id ? this.updateYacht(data, id) : this.storeYacht(data)
  },
  storeYacht(data) {
    return axios.post('/yachts', data)
      .then(response => response.data)
  },
  updateYacht(data, id) {
    return axios.patch(`/yachts/${id}`, data)
      .then(response => response.data)
  },
  fetchYachts(params) {
    return axios.get('/yachts', { params: params })
      .then(response => response.data)
  },
  fetchYacht(id) {
    return axios.get(`/yachts/${id}`)
      .then(response => response.data)
  },
  destroy(id) {
    return axios.delete(`/yachts/${id}`)
  },
  calculateFinance(yachtId, financeModelId, params, suggest = false) {
    return axios.post(`/yachts/${yachtId}/finance/calculate`, {
      finance_model_id: financeModelId,
      parameters: params,
      suggest: suggest
    }).then(response => response.data)
  },
  storeFinance(yachtId, financeModelId, params) {
    return axios.post(`/yachts/${yachtId}/finance/store`, {
      finance_model_id: financeModelId,
      parameters: params
    }).then(response => response.data)
  },
  approveDeal(yachtId) {
    return axios.post(`/yachts/${yachtId}/approve`)
      .then(response => response.data)
  },
  rejectDeal(yachtId, reason) {
    return axios.post(`/yachts/${yachtId}/reject`, {
      reason: reason
    }).then(response => response.data)
  },
  storeDeliveryPlan(yachtId, steps, destinationBaseId = null) {
    return axios.post(`/yachts/${yachtId}/delivery-plan/store`, {
      steps: steps,
      destination_base_id: destinationBaseId
    }).then(response => response.data)
  },
  deleteDeliveryPlan(yachtId) {
    return axios.delete(`/yachts/${yachtId}/delivery-plan`).then(response => response.data)
  },
  toggleEquipmentPackInstalled(yachtId, equipmentPackId, installed) {
    return axios.post(`/yachts/${yachtId}/equipment-packs/toggle-installed`, {
      equipment_pack_id: equipmentPackId,
      installed: installed
    }).then(response => response.data)
  },
  toggleEquipmentPackOrdered(yachtId, equipmentPackId, ordered) {
    return axios.post(`/yachts/${yachtId}/equipment-packs/toggle-ordered`, {
        equipment_pack_id: equipmentPackId,
        ordered: ordered
    }).then(response => response.data)
  },
  updateEquipmentInvoicedPrice(yachtId, equipmentPackId, price) {
    return axios.post(`/yachts/${yachtId}/equipment-packs/update-invoiced-price`, {
      equipment_pack_id: equipmentPackId,
      invoiced_price: price
    }).then(response => response.data)
  },
  toggleLogisticsChecklist(yachtId, type, done) {
    return axios.post(`/yachts/${yachtId}/toggle-logistics-checklist`, {
      type: type,
      done: done
    }).then(response => response.data)
  },
  fetchAudits(yachtId) {
    return axios.get(`/yachts/${yachtId}/audits`)
      .then(response => response.data)
  },
  storeEquipmentPackContractors(yachtId, data) {
    return axios.post(`/yachts/${yachtId}/equipment-packs/contractors`, data)
      .then(response => response.data)
  },
  updateYachtEngineSerialNumbers(yachtId, data) {
    return axios.post(`/yachts/${yachtId}/engine-serial-numbers`, data)
      .then(response => response.data)
  },
  storeAgreementDetails(yachtId, data) {
    return axios.post(`/yachts/${yachtId}/agreement-details`, data)
      .then(response => response.data)
  },
  getLogisticsStats(year) {
    return axios.get(`logistics/stats`, {
      params: {
        year: year
      }
    })
      .then(response => response.data)
  },
  fetchLogisticsYachts(params) {
    return axios.get('/logistics/yachts', { params: params })
      .then(response => response.data)
  },
  updateSpecifications(yachtId, data) {
    return axios.post(`/yachts/${yachtId}/specifications`, data)
      .then(response => response.data)
  },
  getSpecifications(yachtId) {
    return axios.get(`/yachts/${yachtId}/specifications`)
      .then(response => response.data)
  },
  revertInvestmentStatus(data, yachtId) {
    return axios.post(`/yachts/${yachtId}/revert-investment-status`, data)
      .then(response => response.data)
  },
  revertLogisticsStatus(data, yachtId) {
    return axios.post(`/yachts/${yachtId}/revert-logistics-status`, data)
      .then(response => response.data)
  },
  downloadXls(params) {
    return axios.get(`/yachts/export`, { params: params }).then(response => response.data)
  },
  addOrUpdateOtherCosts(yachtId, data) {
    return axios.post(`/yachts/${yachtId}/other-costs`, data)
      .then(response => response.data)
  },
  deleteOtherCost(yachtId, otherCostId) {
    return axios.delete(`/yachts/${yachtId}/other-costs/${otherCostId}`)
      .then(response => response.data)
  }
}
